import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useFormik } from 'formik'
import { Siren } from 'lucide-react'
import Swal from 'sweetalert2'
import { TextArea } from 'components/input_fields'
import { SosSendSchema } from './ValidationSchema'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { sendSos } from '../../../../redux/slices/help_desk'
import { toggleSosModal } from '../../../../redux/slices/globalSlice'
import { addUpdateHandler } from 'utils'
import { useTranslation } from 'react-i18next'

export default function SosTab({ toggle = toggleSosModal }) {

    const [spinner, setSpinner] = useState(false)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const initialValues = {
        description: '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: SosSendSchema,
        onSubmit: async (vals, action) => {
            const result = await Swal.fire({
                title: t('sos.confirm_sos_title'),
                text: t('sos.confirm_sos_text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#dc2626',
                cancelButtonColor: '#64748b',
                cancelButtonText: t('common.cancel'),
                confirmButtonText: t('sos.send_sos'),
                allowOutsideClick: false,
            })

            if (!result.isConfirmed) return

            setSpinner(true)
            dispatch(sendSos({ values: vals })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: res.payload.data.message,
                wrong_toast: t('sos.error_sos'),
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => dispatch(toggle()),
            }))
        },
    })

    return (
        <div className="sos-tab-content">

            <p className="sos-description">{t('sos.description')}</p>

            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
                <div className="row g-2">

                    <div className="col-md-12">
                        <TextArea
                            label_name={t('sos.sos_description')}
                            mandatory={false}
                            placeholder=""
                            rows={3}
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.description && touched.description ? <span className="field_error">{errors.description}</span> : null}
                        />
                    </div>

                    <div className="col-md-12">
                        <button
                            type="submit"
                            className="sos-send-btn"
                            disabled={spinner}
                        >
                            <Siren size={22} />
                            {spinner ? t('sos.sending_sos') : t('sos.send_sos')}
                        </button>
                    </div>
                </div>
            </Form>
        </div>
    )
}